module.exports = __webpack_public_path__ + "img/horizontal_3_2_3.76c6070a.png";